<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <div class="va-card">
        <div class="va-card__header-inner">
          <div class="va-card__header-title" style="color: rgb(44, 130, 224);"> {{ $t('invoices.invoiceForPeriod') }} </div>
        </div>
        <div class="va-card__body">
          <div>
            {{ $t('invoices.invoiceData') }} {{invoice.invoiceId}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  name: 'Invoice',
  data () {
    return {
      invoice: {},
    }
  },
  methods: {
    async initInvoice () {
      this.invoice = this.$store.getters.invoice
      this.$store.commit('setLoading', false)
    },
  },
  computed: {},
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getInvoice', this.$route.params.invoiceId)
      .then(() => this.initInvoice())
      .catch((err) => this.errorHandler(err.response))
  },
}
</script>

<style scoped type="scss">
</style>
